import { db } from './config';
import { collection, doc, setDoc, getDoc, getDocs, deleteDoc, query, orderBy } from 'firebase/firestore';

/**
 * Yeni bir şablon kaydet
 * @param {string} userId - Kullanıcı ID
 * @param {object} templateData - Şablon verisi
 * @returns {Promise<{success: boolean, data?: object, error?: string}>}
 */
export const saveTemplate = async (userId, templateData) => {
  try {
    const templateId = `template_${Date.now()}`;
    const templateRef = doc(db, 'users', userId, 'templates', templateId);

    const template = {
      id: templateId,
      name: templateData.name || 'İsimsiz Şablon',
      content: templateData.content || '',
      media: templateData.media || [],
      platformCustomization: templateData.platformCustomization || {},
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };

    await setDoc(templateRef, template);

    return {
      success: true,
      data: template
    };
  } catch (error) {
    console.error('Template kaydetme hatası:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Kullanıcının tüm şablonlarını getir
 * @param {string} userId - Kullanıcı ID
 * @returns {Promise<{success: boolean, data?: array, error?: string}>}
 */
export const getAllTemplates = async (userId) => {
  try {
    const templatesRef = collection(db, 'users', userId, 'templates');
    const q = query(templatesRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);

    const templates = [];
    querySnapshot.forEach((doc) => {
      templates.push(doc.data());
    });

    return {
      success: true,
      data: templates
    };
  } catch (error) {
    console.error('Şablonları getirme hatası:', error);
    return {
      success: false,
      error: error.message,
      data: []
    };
  }
};

/**
 * Belirli bir şablonu getir
 * @param {string} userId - Kullanıcı ID
 * @param {string} templateId - Şablon ID
 * @returns {Promise<{success: boolean, data?: object, error?: string}>}
 */
export const getTemplate = async (userId, templateId) => {
  try {
    const templateRef = doc(db, 'users', userId, 'templates', templateId);
    const templateDoc = await getDoc(templateRef);

    if (!templateDoc.exists()) {
      return {
        success: false,
        error: 'Şablon bulunamadı'
      };
    }

    return {
      success: true,
      data: templateDoc.data()
    };
  } catch (error) {
    console.error('Şablon getirme hatası:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Şablonu güncelle
 * @param {string} userId - Kullanıcı ID
 * @param {string} templateId - Şablon ID
 * @param {object} updates - Güncellenecek veriler
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export const updateTemplate = async (userId, templateId, updates) => {
  try {
    const templateRef = doc(db, 'users', userId, 'templates', templateId);

    const updatedData = {
      ...updates,
      updatedAt: new Date().toISOString()
    };

    await setDoc(templateRef, updatedData, { merge: true });

    return {
      success: true
    };
  } catch (error) {
    console.error('Şablon güncelleme hatası:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Şablonu sil
 * @param {string} userId - Kullanıcı ID
 * @param {string} templateId - Şablon ID
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export const deleteTemplate = async (userId, templateId) => {
  try {
    const templateRef = doc(db, 'users', userId, 'templates', templateId);
    await deleteDoc(templateRef);

    return {
      success: true
    };
  } catch (error) {
    console.error('Şablon silme hatası:', error);
    return {
      success: false,
      error: error.message
    };
  }
};
